<template>

<div :class="['list-view', showDetail ? 'no-sub-header' : '']">

	<div v-if="!showDetail" class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div :class="['button', loading ? 'disabled' : 'action', 'input-go']" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="!showDetail" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
        <div v-if="!showDetail">
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
					<label>Hidden</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
					<label>Inactive</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.expired ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('expired')"></span>
					<label>Expired</label>
				</li>
			</ul>
			<div class="divider"></div>
            <div class="button action" @click="addItem()">New Class</div>
			<div class="divider"></div>
			<div :class="['extra-menu-item', gettingExport ? 'disabled' : '']" @click="doExport()">Export CSV</div>
			<div v-if="exportMessage" class="message">{{ exportMessage }}</div>
			<div class="extra-menu-item" @click="addClassesToWebsite = true">Add Classes to Website</div>
			<div class="extra-menu-item" @click="$router.push('/range-memberships/class-calendar/calendar')">Class Calendar</div>
			<div class="extra-menu-item" @click="$router.push('/range-memberships/class-calendar/enrollment')">Enrollment List</div>
			<div v-if="getDevEnvironment" class="divider"></div>
			<div v-if="getDevEnvironment" class="extra-menu-item" @click="getList()">Reload List</div>
        </div>

		<div v-else>
			<div :class="['filter-list-button-large', { active : showDetailTab == 'info' }]" @click="fetchDetailTab('info')">Class Info</div>
			<div :class="['filter-list-button-large', { disabled: !class_detail_id }, { active : showDetailTab == 'dates' }]" @click="fetchDetailTab('dates')">Dates</div>
			<div :class="['filter-list-button-large', { disabled: !class_detail_id }, { active : showDetailTab == 'registration' }]" @click="fetchDetailTab('registration')">Registration</div>
			<div :class="['filter-list-button-large', { disabled: !class_detail_id }, { active : showDetailTab == 'notifications' }]" @click="fetchDetailTab('notifications')">Notifications</div>
			<div :class="['filter-list-button-large', { disabled: !class_detail_id }, { active : showDetailTab == 'products' }]" @click="fetchDetailTab('products')">Related Products</div>
			<button :class="['button', canSave ? 'action' : 'disabled']" @click="saveItem()">Save</button>
            <button :class="['button', loading ? 'disabled' : 'neutral' ]" @click="backToList()">Back to List</button>
			<div class="divider"></div>
			<div :class="['extra-menu-item', { disabled: !class_detail_id }]" @click="showConfirmCloneClass = true">Clone Class</div>
        </div>

	</div>

	<loading v-if="loading" class="loading"></loading>

	<div v-else-if="showDetail" class="detail">
		<div v-if="showDetailTab == 'info'">
			<div class="class-detail-section three-one-columns">
				<div>
					<div class="two-columns">
						<div>
							<label-required :label="'Class Name'" :condition="detail.description" />
							<input type="text" v-model="detail.description" />
							<label-required :label="'UPC'" :condition="detail.upc" />
							<input type="text" v-model="detail.upc" />
							<div class="two-columns">
								<label-required :label="'Price Per Class'" :condition="detail.price" />
								<label>Cost Basis</label>
								<number-input :decimals='2' v-model="detail.price" :key="'price_' + detail.product_id" />
								<number-input :decimals='2' v-model="detail.cost" :key="'cost_' + detail.product_id" />
							</div>
						</div>
						<div>
							<div class="two-columns">
								<div>
									<label-required :label="'Seats Available'" :condition="detail.seats_available" />
									<number-input :decimals='0' :min="1" v-model="detail.seats_available" />
								</div>
								<!-- <checkbox v-model="detail.unlimited_seats" label="Unlimited Seats"/> -->
							</div>
							<label>Default Instructor</label>
							<input type="text" v-model="detail.default_instructor" />
							<div class="two-columns" style="margin: 0.33em 0;">
								<!-- <checkbox v-model="detail.member_required" label="Members Only"/> -->
								<checkbox v-model="detail.not_taxable" label="Not Taxable" :key="'not_taxable_' + detail.product_id"/>
								<!-- <checkbox v-model="detail.require_pos_customer" label="Require POS Customer" :key="'require_pos_customer_' + detail.product_id"/> -->
							</div>
							<div class="two-columns" style="margin: 0em 0;">
								<checkbox v-model="detail.internal_use_only" label="Hidden Online" :key="'hidden_' + detail.product_id"/>
								<checkbox v-model="detail.inactive" label="Inactive" :key="'inactive_' + detail.product_id"/>
							</div>
						</div>
					</div>

					<label>Class Description</label>
					<ckeditor :editor="editor" v-model="detail.detailed_description" :config="editorConfig"></ckeditor>

				</div>

				<div style="margin-left: 2em; padding-left: 2em; border-left: 1px solid #ccc;">

					<div v-if="detail.product_id" class="center">
						<img v-if="detail.image_src" :src="detail.image_src" style="width: 240px;" />
						<div style="margin: 1em 0 0 0;">
							<div class="button neutral" @click="showImageUplaod = true">{{ detail.image_src && !detail.default_image ? 'Change' : 'Upload' }} Image</div>
						</div>
						<div v-if="detail.default_image" class="note v-spaced">This is a placeholder image.<br>Upload your own image to have this class<br>display on your website.</div>
					</div>

				</div>
			</div>
        </div>

		<div v-if="showDetailTab == 'dates'">
			<div class="tab-section-title">{{ detail.description }}</div>
			<div class="class-detail-section two-one-columns">
				<div>
					<h3>This class is offered...</h3>
					<div class="two-columns" style="margin: 0 0 1em 0;">
						<div :class="['button', detail.recurring ? 'action' : 'neutral']" @click="detail.recurring = true">At regular intervals</div>
						<div :class="['button', detail.recurring ? 'neutral' : 'action']" @click="detail.recurring = false">Once or at irregular intervals</div>
					</div>
					<div v-if="detail.recurring" style="margin: 1em 0 0 0;">
						<div class="four-columns" style="margin: 1em 0 0 0;">
							<div>
								<label-required :label="(detail.dates[0].multi_session ? 'Session 1 ' : '') + 'Initial Date'" :condition="detail.dates[0].date" />
								<input type="date" v-model="detail.dates[0].date" style="display: block; width: 10em;" />
							</div>
							<div>
								<label>{{ detail.dates[0].multi_session ? 'Session 1 ' : '' }}Start Time</label>
								<input type="time" v-model="detail.dates[0].start_time" style="display: block; width: 10em;" />
							</div>
							<div>
								<label>{{ detail.dates[0].multi_session ? 'Session 1 ' : '' }}End Time</label>
								<input type="time" v-model="detail.dates[0].end_time" style="display: block; width: 10em;" />
							</div>
							<div>
								<label>{{ detail.dates[0].multi_session ? 'Session 1 ' : '' }}Instructor</label>
								<input type="text" v-model="detail.dates[0].instructor" style="display: block; max-width: 26em;" />
							</div>
						</div>

						<div class="two-columns" style="margin: 1em 0 0 0;">
							<div>
								<!-- <label>Repeat Every</label> -->
								<label-required label="Repeat Every" :condition="detail.class_frequency_code" />
								<div :class="{ 'one-two-columns': detail.class_frequency_code == 'WEEK' }">
									<select v-if="detail.class_frequency_code == 'WEEK'" v-model="detail.class_frequency_unit">
										<option value="1">1</option>
										<option value="2">2</option>
										<option value="3">3</option>
										<option value="4">4</option>
									</select>
									<select v-model="detail.class_frequency_id" @change="setClassFrequencyCode()">
										<option value="">Select...</option>
										<option v-for="(frequency, index) in classFrequencies" :value="frequency.class_frequency_id">{{ frequency.description }}</option>
									</select>
								</div>
							</div>
							<div>
								<label>End Repeat After</label>
								<input type="date" v-model="detail.class_frequency_end_date" style="display: block; width: 10em;" />
							</div>
						</div>

						<div v-if="detail.class_frequency_code == 'MONTH'">
							<label>Repeat on</label>
							<binary-toggle v-model="detail.class_frequency_month_as_date" labels="Weekday of month,Day of month" values="0,1" />
						</div>

						<div v-if="repeatDescription" style="margin: 1em 0;">
							<h3>This class repeats...</h3>
							{{ repeatDescription }}
						</div>

						<div style="margin: 1em 0; padding: 1em 0; border-top: 1px solid #ccc;">
							<checkbox v-model="detail.dates[0].multi_session" label="This class includes more than one session"/>
							<div v-if="detail.dates[0].multi_session" style="margin: 1em 0 0 0;">
								<p>A multi-session class is a series of classes that are all part of the same class. For example, a two-day CCW class that meets on a Friday and a Saturday is a multi-session class.</p>
								<label>How many <b>additional</b> sessions are part of this class?</label>
								<select v-model="detail.dates[0].session_count" style="width: 6em; margin: 0 0 0 1em;" @change="populateMultiSessions(detail.dates[0])">
									<option value="0">Select...</option>
									<option v-for="index in [1,2,3,4,5,6,7,8,9,10]" :value="index">{{ index }}</option>
								</select>

								<div v-for="(session, index) in detail.dates[0].sessions" class="four-columns" style="border-top: 1px solid #ccc; margin: 0.5em 0 0 1em; padding: 0.5em 0 0 0;">
									<div>
										<label-required :label="'Session ' + (index + 2) + ' Initial Date'" :condition="session.date" />
										<input type="date" v-model="session.date" :min="detail.dates[0].date" style="display: block; width: 10em;" :key="'session_date_' + index" />
									</div>
									<div>
										<label>Session {{ index + 2 }} Start Time</label>
										<input type="time" v-model="session.start_time" style="display: block; width: 10em;" />
									</div>
									<div>
										<label>Session {{ index + 2 }} End Time</label>
										<input type="time" v-model="session.end_time" style="display: block; width: 10em;" />
									</div>
									<div>
										<label>Session {{ index + 2 }} Instructor</label>
										<input type="text" v-model="session.instructor" />
									</div>
								</div>

							</div>
						</div>
					</div>
					<div v-else style="margin: 1em 0 0 0;">
						<div v-for="(date, index) in detail.dates" style="border-bottom: 1px solid #ccc; margin: 0 0 1em 0;">
							<div class="five-columns" style="grid-template-columns: 1fr 1fr 1fr 1fr 2em;">
								<div>
									<label-required :label="(date.multi_session ? 'Session 1 ' : '') + 'Date'" :condition="date.date" />
									<input type="date" v-model="date.date" style="display: block; width: 10em;" />
								</div>
								<div>
									<label>{{ date.multi_session ? 'Session 1 ' : '' }}Start Time</label>
									<input type="time" v-model="date.start_time" style="display: block; width: 10em;" />
								</div>
								<div>
									<label>{{ date.multi_session ? 'Session 1 ' : '' }}End Time</label>
									<input type="time" v-model="date.end_time" style="display: block; width: 10em;" />
								</div>
								<div>
									<label>{{ date.multi_session ? 'Session 1 ' : '' }}Instructor</label>
									<input type="text" v-model="date.instructor" />
								</div>
								<div class="right"><div v-if="detail.dates.length > 1" :class="['button', detail.reservations > 0 ? 'disabled' : 'neutral', 'inline']" @click="removeDateTime(index)"><i class="fa fa-trash" /></div></div>
							</div>

							<div style="margin: 0.5em 0;">
								<checkbox v-model="date.multi_session" label="This class includes more than one session"/>
								<div v-if="date.multi_session" style="margin: 1em 0 0 0;">
									<p>A multi-session class is a series of classes that are all part of the same class. For example, a two-day CCW class that meets on a Friday and a Saturday is a multi-session class.</p>
									<label>How many <b>additional</b> sessions are part of this class?</label>
									<select v-model="date.session_count" style="width: 6em; margin: 0 0 0 1em;" @change="populateMultiSessions(date)">
										<option value="0">Select...</option>
										<option v-for="index in [1,2,3,4,5,6,7,8,9,10]" :value="index">{{ index }}</option>
									</select>

									<div v-for="(session, index) in date.sessions" class="four-columns" style="border-top: 1px solid #ccc; margin: 0.5em 0 0 1em; padding: 0.5em 0 0 0;">
										<div>
											<label-required :label="'Session ' + (index + 2) + ' Initial Date'" :condition="session.date" />
											<input type="date" v-model="session.date" :min="date.date" style="display: block; width: 10em;" :key="'session_date_' + index" />
										</div>
										<div>
											<label>Session {{ index + 2 }} Start Time</label>
											<input type="time" v-model="session.start_time" style="display: block; width: 10em;" />
										</div>
										<div>
											<label>Session {{ index + 2 }} End Time</label>
											<input type="time" v-model="session.end_time" style="display: block; width: 10em;" />
										</div>
										<div>
											<label>Session {{ index + 2 }} Instructor</label>
											<input type="text" v-model="session.instructor" />
										</div>
									</div>

								</div>
							</div>
						</div>
						<div style="margin: 0 0 2em 0;">
							<div :class="['button', detail.dates[detail.dates.length - 1].date ? 'action' : 'disabled', 'small', 'spaced']" @click="addDateTime()"><i class="fa fa-plus"></i></div>
							<label>Add another date to this class</label>
						</div>
					</div>
				</div>
				<div v-if="detail.recurring" style="margin: 6.5em 2em 0 2em;">
					<p>Set the Intial Date, Start Time, End Time and instructor for this class.</p>
					<p>The class will automatically repeat on your class calendar based on the Repeat Every and End Repeat After settings.</p>
				</div>
				<div v-else style="margin: 6.5em 2em 0 2em;">
					<p>Set at least one Date, Start Time, End Time and instructor for this class.</p>
					<p>Add as many additional dates as planned.</p>
					<p>Deleting or editing past dates will not affect any reservations associated with those dates.</p>
				</div>
			</div>
		</div>

		<div v-if="showDetailTab == 'registration'" class="tab-content">
			<div class="tab-section-title">{{ detail.description }}</div>
			<div class="class-detail-section three-one-columns">

				<div>
					<div class="three-columns" style="margin: 0 0 1em 0;">
						<div>
							<label style="display:inline;">Registration closes</label>
							<number-input :decimals='0' v-model="detail.registration_closes_days_before"/>
							<label style="display:inline;">days before class starts</label>
						</div>
						<div>
							<label>Early registration closes</label>
							<number-input :decimals='0' v-model="detail.early_registration_closes_days_before"/>
							<label style="display:inline;">days before class starts</label>
						</div>
						<div>
							<label>Early registration discount</label>
							<number-input :decimals='2' v-model="detail.early_registration_discount"/>
							<label style="display:inline;">dollar amount</label>
						</div>
					</div>

					<div style="margin: 0 0 1em 0;">
						<label>Extra Required Registration Information</label>
						<div v-for="(value, name) in detail.registration_required_fields" class="v-spaced">
							<checkbox v-model="detail.registration_required_fields[name]" :label="name.capitalizeWords()"/>
						</div>
						<div class="note">NOTE: name, address, phone and email are required by default.</div>
					</div>

					<label>Terms / Requirements for Registration</label>
					<ckeditor :editor="editor" v-model="detail.registration_terms" :config="editorConfig"></ckeditor>

				</div>
				<div>
					<div class="center" style="margin: 0 0 0 2em;">
						<img :src="detail.waiver_image_src" />
						<div style="margin: 1em 0 0 0;">
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="showDetailTab == 'notifications'" class="tab-content">
			<div class="tab-section-title">{{ detail.description }}</div>
			<div class="class-detail-section">

				<div class="two-columns" style="margin: 1em 0;">
					<p>Email reminders will automatically include the Class Name, Description, Date and Time when enabled. You can add your own custom message with the email reminder as well.</p>
					<p>Text reminders will automatically include the Class Name, Description, Date and Time when enabled. You can add your own custom message with the text reminder as well.</p>
					<div>
						<checkbox v-model="detail.enable_email_reminder" label="Enable Email Reminder"/>
							<div v-if="detail.enable_email_reminder" style="margin: 1em 0 0 0;">
							<label style="display:inline;">Send email</label>
							<select v-model="detail.email_reminder_days" style="width: 7em; margin: 0 0.5em;">
								<option value="">Select...</option>
								<option value="1">One day</option>
								<option value="2">Two days</option>
								<option value="3">Three days</option>
							</select>
							<label style="display:inline;">before class starts</label>
						</div>
					</div>
					<div>
						<checkbox v-model="detail.enable_text_reminder" label="Enable Text Reminder"/>
						<div v-if="detail.enable_text_reminder" style="margin: 1em 0 0 0;">
							<label style="display:inline;">Send text</label>
							<select v-model="detail.text_reminder_days" style="width: 7em; margin: 0 0.5em;">
								<option value="">Select...</option>
								<option value="1">One day</option>
								<option value="2">Two days</option>
								<option value="3">Three days</option>
							</select>
							<label style="display:inline;">before class starts</label>
						</div>
					</div>
					<div style="margin: 1em 0 0 0;">
						<label>Custom Email Subject</label>
						<input type="text" v-model="detail.email_reminder_subject" />
						<label>Custom Email Content</label>
						<ckeditor :editor="editor" v-model="detail.email_reminder_content" :config="editorConfig"></ckeditor>
					</div>
					<div style="margin: 1em 0 0 0;">
						<label>Custom Text Content</label>
						<textarea v-model="detail.text_reminder_content"/>
					</div>

					<div class="controls">
						<div class="button neutral" @click="showTestNotification = 'email'">Send Test Email</div>
					</div>
					<div class="controls">
						<div class="button neutral" @click="showTestNotification = 'text'">Send Test Text</div>
					</div>

					<div style="margin: 1em 0 0 0;">
						<p>Customer replies to reminder emails and texts can be forwarded to a specific email address.  The default is your store profile email address.</p>
						<input type="text" v-model="detail.email_reply_to" />
					</div>

				</div>
			</div>
		</div>

		<div v-if="showDetailTab == 'products'" class="tab-content">
			<div class="tab-section-title">{{ detail.description }}</div>
			<div class="class-detail-section">
				<h2>Products</h2>
				<table class="data-list" width="100%" cellpadding="9" cellspacing="0">
					<thead>
						<tr>
							<th class="list center"></th>
							<th class="list left">Description</th>
							<th class="list left">UPC</th>
							<th class="list right">Available</th>
							<th class="list right">Price</th>
							<th class="list right"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(product, index) in detail.products" class="draggable">
							<td class="list center" width="40"><img :src="product.image_src" /></td>
							<td class="list left">{{ product.description }}</td>
							<td class="list left">{{ product.upc }}</td>
							<td class="list right">{{ product.available }}</td>
							<td class="list right">{{ product.price }}</td>
							<td class="list right">
								<div class="button neutral smaller" @click="removeProduct(product)"><i class='fa fa-trash' /></div>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="controls">
					<div class="button action" @click="addingProducts = true">Add products</div>
				</div>
			</div>
		</div>

	</div>

	<div v-else class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

        <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Description</th>
					<th class="list">UPC</th>
					<th class="list">Date</th>
					<th class="right">Seats</th>
					<th class="right">Enrolled</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="goToItem(item.class_detail_id)">
                <td class="list left">{{ item.product }}</td>
                <td class="list left">{{ item.upc }}</td>
                <td class="list left">{{ item.date }}</td>
                <td class="list right">{{ item.seats_available }}</td>
                <td class="list right">{{ item.reservations }}</td>
            </tr>
        </table>

	</div>

	<div v-if="showTestNotification" class="modal">
		<div class="inner">
			<h2>Send a Test {{ showTestNotification }}</h2>
			<div class="content">
				<label v-if="showTestNotification == 'text'">Enter a phone number</label>
				<label v-else>Enter an email address</label>
				<input type="text" v-model="testNotificationRecipient" :disabled="sendingTest"/>
				<div class="message">{{ testNotificationMessage }}</div>
				<div v-if="sendingTest" class="center"><i class="fa fa-spinner fa-spin"></i></div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showTestNotification = ''">Cancel</div>
				<div :class="['button', 'spaced', sendingTest || !testNotificationRecipient ? 'disabled' : 'action']" @click="sendTestNotification()">Send {{ showTestNotification }}</div>
			</div>
		</div>
	</div>

	<div v-if="showImageUplaod" class="modal">
		<div class="inner uploader">
			<h2>Upload Class Image</h2>
			<div class="content">
				<div class="two-columns">
					<div class="image-preview">
						<img v-if="currentImageSrc" :src="currentImageSrc" style="max-width: 90%;">
					</div>
					<div>
						<vue-dropzone @vdropzone-success="uploadSuccess" ref="imageDropzone" id="image_dropzone" :options="dropzoneOptions"></vue-dropzone>
						<div v-if="!detail.default_image" style="margin: 1em 0 0 0; line-height: 2em;">
							<div class="tab-section-title">Current Image</div>
							<div class="two-columns">
								<label>Type:</label><div>{{ imageData.file_type }}</div>
								<label>Width:</label><div>{{ imageData.width }}px</div>
								<label>Height:</label><div>{{ imageData.height }}px</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="cancelImageUpload()">{{ imageUploadComplete ? 'Done With Upload' : 'Cancel' }}</div>
			</div>
		</div>
	</div>

	<div v-if="addClassesToWebsite" class="modal">
		<div class="inner">
			<h2>Add Classes Link to Your Website</h2>
			<div class="content">
				<label>Menu Label</label>
				<input type="text" placeholder="Classes" value="Classes" v-model="preferences.classes_menu_label"/>
				<h5>Where do you want the link to your classes to appear on your website?</h5>
				<div class="one-two-columns" style="align-items: start;">
					<checkbox label="Pages Menu" v-model="preferences.classes_in_pages_menu"/>
					<div class="instruction">The menu at the top of your website, above your logo.</div>
					<checkbox label="Products Menu" v-model="preferences.classes_in_product_nav_menu"/>
					<div class="instruction">The menu just below your logo and cart.</div>
					<checkbox label="Footer Menu" v-model="preferences.classes_in_footer_menu"/>
					<div class="instruction">The menu at the very bottom of your website.</div>
				</div>
				<br><div class="note">Note: You can also manage your website links through the <a href="/dashboard/website/menus" target="_blank"><u>Menus</u></a> program.</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="addClassesToWebsite = ''">Cancel</div>
				<div class="button spaced action" @click="savePreferences()">Save</div>
			</div>
		</div>
	</div>

	<div v-if="showConfirmCloneClass" class="modal">
		<div class="inner">
			<h2>Clone This Class</h2>
			<div class="content">
				<p>Cloning copies a class to a brand new one so you can change info and settings.</p>
				<p>If you simply want to add more dates to this class, use the Dates section.</p>
				<p>Are you sure you want to clone this class?</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showConfirmCloneClass = false">Cancel</div>
				<div class="button spaced action" @click="cloneItem()">Yes, Clone Class</div>
			</div>
		</div>
	</div>


	<product-search v-if="addingProducts" @assignProduct="assignProduct" @cancel="addingProducts = false" />

	<help-popup :helpLink="{386:'Classes', 387:'Class Registration Info', 388:'Class Notifications', 389:'Class Related Products', 390:'Class Enrollment', 391:'Class Calendar View', 392:'Selling Classes'}" :tours="false"></help-popup>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import List from '@ckeditor/ckeditor5-list/src/list';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import { Undo, Redo } from '@ckeditor/ckeditor5-undo/src/';

import CDSUploadAdapter from '@/modules/website/components/contentpagesuploadadapter.js';

import Loading from '@/components/Loading.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import NumberInput from '@/components/NumberInput.vue'
import BinaryToggle from '@/components/BinaryToggle.vue'
import CDSDateInput from '@/components/CDSDateInput.vue'
import Checkbox from '@/components/Checkbox.vue'
import ProductSearch from '@/components/ProductSearch.vue'
import vue2Dropzone from 'vue2-dropzone'

// We use version 5! npm i vue-simple-calendar@5.0.1
import 'vue-simple-calendar/static/css/default.css'
import CalendarView from "vue-simple-calendar/src/components/CalendarView.vue"
import CalendarViewHeader from "vue-simple-calendar/src/components/CalendarViewHeader.vue"

import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'classes',
	props: ['class_detail_id'],
    components: {
        'ckeditor': CKEditor.component,
        'loading': Loading,
		'label-required': LabelRequired,
		'number-input': NumberInput,
		'date-input': CDSDateInput,
		'checkbox': Checkbox,
		'product-search': ProductSearch,
        'vue-dropzone': vue2Dropzone,
		'binary-toggle': BinaryToggle,
		'calendar-view': CalendarView,
		'calendar-view-header': CalendarViewHeader,
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			searching: false,
            message: '',
            messageStatus: '',
            messageTimeout: 0,
			classFrequencies: [],
			filters: {},
			list: [],
			paging: {},
			preferences: {
				classes_menu_label: 'Classes'
			},
			showDetail: false,
			showDetailTab: '',
			getEnrolled: false,
			showDate: new Date(),
			today: '',
			detail: {},
			multiSessionClass: false,
			gettingExport: false,
			exportMessage: '',
			showTestNotification: '',
			testNotificationRecipient: '',
			sendingTest: false,
			testNotificationMessage: '',
			reservationFilters: {
				start_date: '',
				end_date: ''
			},
			classEnrollment: [],
			classEnrollmentByDate: [],
			showEnrolledDetail: false,
			enrollmentDetail: {},
			enrollmentDate: '',
			exportEnrollmentByDate: false,
			showAddEnrollment: false,
			confirmRemoveEnrollment: false,
			customerSearchTerm: '',
			searchMessage: '',
			customerList: [],
			calendarDetail: {},
			showImageUplaod: false,
			imageData: {},
			currentImageSrc: '',
			imageUploadComplete: false,
			addClassesToWebsite: false,
			showConfirmCloneClass: false,
			addingProducts: false,
			editor: ClassicEditor,
			editorConfig: {
                plugins: [
					Alignment,
					Image,
					ImageToolbar,
					ImageCaption,
					ImageStyle,
					ImageResize,
					ImageUpload,
                    Bold,
                    Italic,
					Underline,
                    Link,
                    Paragraph,
					Heading,
					List,
					MediaEmbed,
					Undo
                ],
                toolbar: {
                    items: [
                        'bold',
                        'italic',
						'underline',
						'heading',
						'link',
						'alignment:left',
						'alignment:center',
						'alignment:right',
						'numberedList',
						'bulletedList',
						'imageUpload',
						'mediaEmbed',
                        'undo',
                        'redo',
                    ]
                },
				extraPlugins: [ this.theUploadAdapterPlugin ],
				heading: {
		            options: [
		                { model: 'paragraph', title: 'Paragraph' },
		                { model: 'heading1', view: 'h1', title: 'Heading 1' },
						{ model: 'heading2', view: 'h2', title: 'Heading 2' },
		                { model: 'heading3', view: 'h3', title: 'Heading 3' },
					]
				},
				image: {
		            // You need to configure the image toolbar, too, so it uses the new style buttons.
		            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
		            styles: [
		                // This option is equal to a situation where no style is applied.
		                'full',
		                // This represents an image aligned to the left.
		                'alignLeft',
		                // This represents an image aligned to the right.
		                'alignRight'
		            ]
		        },
				mediaEmbed: {
					removeProviders: [ 'dailymotion', 'spotify', 'instagram', 'twitter', 'googleMaps', 'flickr', 'facebook' ] // 'vimeo', 
				}
            },
		}
	},
	created() {
		this.getClassFrequencies()
		this.clearFilters()
		this.today = this.showDate.getFullYear() + '-' + (this.showDate.getMonth() + 1).toString().padStart(2,'0') + '-' + this.showDate.getDate().toString().padStart(2,'0')
	},
	computed: {
		canSave() {
			return this.detail.description && this.detail.upc && this.detail.price && this.detail.seats_available > 0 && (!this.detail.recurring || (this.detail.recurring && this.detail.class_frequency_code))
		},
		repeatDescription() {
			let weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
			let date = new Date(this.detail.dates[0].date)
			let weekday = weekdays[date.getDay()]
			let dayOfMonth = date.getDate() + 1
			let description = ''
			let days = []
			switch (this.detail.class_frequency_code) {
				case 'DAY':
					description += 'Every day'
					break;
				case 'WEEK':
					description += 'Every '
					switch (this.detail.class_frequency_unit.toString()) {
						case '2':
							description += 'other '
							break
						case '3':
							description += 'third '
							break
						case '4':
							description += 'fourth '
							break
					}
					for (let i = 0; i < this.detail.dates.length; i++) {
						let date = new Date(this.detail.dates[i].date)
						days.push(weekdays[date.getDay()])
					}
					description += days.join(' + ')
					break;
				case 'MONTH':
					description += 'The '
					for (let i = 0; i < this.detail.dates.length; i++) {
						let date = new Date(this.detail.dates[i].date)
						weekday = weekdays[date.getDay()]
						dayOfMonth = date.getDate() + 1
						if (this.detail.class_frequency_month_as_date != 1) {
							let ordinal = '1st'
							if (dayOfMonth > 7) {
								ordinal = '2nd'
							}
							if (dayOfMonth > 14) {
								ordinal = '3rd'
							}
							if (dayOfMonth > 21) {
								ordinal = '4th'
							}
							days.push(ordinal + ' ' + weekday)
						} else {
							days.push(dayOfMonth + (dayOfMonth > 0 ? ['th', 'st', 'nd', 'rd'][(dayOfMonth > 3 && dayOfMonth < 21) || dayOfMonth % 10 > 3 ? 0 : dayOfMonth % 10] : ''))
						}
					}
					description += days.join(' + ') + ' of each month'
					break;
				case 'QUARTER':
					break;
				case 'YEAR':
					break;
				default:
					//description = 'Select how often this class repeats'
					break;
			}
			if (this.detail.class_frequency_code && this.detail.dates[0].start_time) {
				description += ' from ' + this.$moment(this.detail.dates[0].start_time, 'HH:mm:ss').format('h:mmA')
			}
			if (this.detail.class_frequency_code && this.detail.dates[0].end_time) {
				description += ' to ' + this.$moment(this.detail.dates[0].end_time, 'HH:mm:ss').format('h:mmA')
			}
			if (this.detail.class_frequency_code && this.detail.dates[0].date) {
				description += ' starting on ' + this.$moment(this.detail.dates[0].date).format('MM/DD/YYYY')
			}
			if (this.detail.class_frequency_end_date) {
				description += ' through ' + this.$moment(this.detail.class_frequency_end_date).format('MM/DD/YYYY')
			} else if (this.detail.end_auto) {
				description += ' for one year'
			}
			return description
		},
		dropzoneOptions() {
			return {
				url: this.getApiEndpoint + '?action=upload_product_image',
				acceptedFiles: 'image/*',
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 2.0,
				addRemoveLinks: false,
				thumbnailMethod: 'contain',
				dictDefaultMessage: 'Drop an image file here, or click to find an image...',
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'INVENTORY',
					context: 'PRODUCT',
					product_id: this.detail.product_id,
					image_id: this.detail.image_id || ''
				}
			}
		}
	},
    watch: {
		class_detail_id: function() {
            if (this.class_detail_id) {
    			this.getItem()
            } else {
                this.getList()
            }
		}
	},
	methods: {
		theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
		getClassFrequencies() {
			this.apiCall({ destination: 'get_list_class_frequencies' }).then(obj => {
				this.classFrequencies = obj.class_frequencies
			}).catch(err => {
				console.log(err)
			})
		},
		setClassFrequencyCode() {
			this.classFrequencies.forEach((frequency) => {
				if (frequency.class_frequency_id == this.detail.class_frequency_id) {
					this.detail.class_frequency_code = frequency.class_frequency_code
				}
			})
		},
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				internal_use_only: 0,
				inactive: 0,
				do_export: 0
			}
			if (this.$route.query.new) {
				this.addItem(this.$route.query.new)
			} else if (this.class_detail_id) {
                this.getItem()
            } else {
    			this.getList()
            }
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
            this.showDetail = false
            this.detail = {}
			this.apiCall({ destination: 'get_list_class_details', data: this.filters }).then(obj => {
				this.loading = false
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = obj.download_url
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					if (obj.paging) {
						this.paging = obj.paging
					}
					if (obj.preferences) {
						this.preferences = obj.preferences
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		savePreferences() {
			this.apiCall({ destination: 'save_item_class_menu_preferences', data: this.preferences } ).then(obj => {
				if (obj.status == 'success') {
					this.message = 'Classes Link Saved!'
					setTimeout(() => { this.message = '' }, 1500)
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
        goToItem(itemId) {
            this.$router.push('/range-memberships/classes/' + itemId)
        },
		fetchDetailTab(detailTab, forceReload = false) {
			if (!this.class_detail_id) { return }
			if (detailTab == this.showDetailTab) { return }
			if (detailTab == 'dates' && this.detail.dates.length == 0) { 
				this.detail.dates.push({ date: '', start_time: '12:00', end_time: '12:00', instructor: '', multi_session: false, session_count: 0, sessions: []})
			}
			this.showDetailTab = detailTab
		},
		assignProduct(product) {
			this.addingProducts = false
			// make sure it's not already in the list
			let inList = false
			this.detail.products.forEach(row => {
				if (row.product_id == product.product_id) {
					inList = true
				}
			})
			if (!inList) {
				this.detail.products.push(product)
			}
		},
		removeProduct(product) {
			for (var index = 0; index < this.detail.products.length; index++) {
				if (this.detail.products[index].product_id == product.product_id) {
					this.detail.products.splice(index, 1);
				}
			}
		},
		getItem() {
			if (this.loading) { return }
			this.loading = true
			this.messageStatus = ''
			this.apiCall({ destination: 'get_item_class_detail', data: { class_detail_id: this.class_detail_id } }).then(obj => {
				this.loading = false
                if (obj.status == 'success') {
					this.detail = obj.detail
					if (!this.showDetailTab) {
						this.showDetailTab = 'info'
					}
					if (this.detail.image_src) {
						this.currentImageSrc = this.detail.image_src
					}
					if (this.detail.dates.length == 0) {
						this.detail.dates.push({ start_time: '12:00', end_time: '12:00' })
					}
                    this.showDetail = true
				} else {
                    this.message = obj.message
                    this.messageStatus = obj.status
                }
			}).catch(err => {
				console.log(err)
			})
		},
		populateMultiSessions(dateObject) {
			let sessions = []
			let useDate = this.$moment(dateObject.date)
			for (let i = 0; i < dateObject.session_count; i++) {
				if (dateObject.sessions[i]) {
					sessions.push(dateObject.sessions[i])
					useDate = this.$moment(dateObject.sessions[i].date)
				} else {
					// increment originalDate by one day
					useDate = this.$moment(useDate).add(1, 'days')
					// add new session with formatted originalDate
					sessions.push({ date: this.$moment(useDate).format('YYYY-MM-DD'), start_time: dateObject.start_time, end_time: dateObject.end_time })
				}
			}
			dateObject.sessions = sessions
		},
        backToList() {
			this.showDetailTab = ''
			this.showDetail = false
			if (this.class_detail_id || this.$route.query.new) {
	            this.$router.push('/range-memberships/classes/')
				this.getList()
			}
        },
		addItem(productId) {
			this.detail = {
				product_id: '',
				description: '',
				detailed_description: '',
				price: '',
				cost: '',
				internal_use_only: 0,
				inactive: 0,
				not_taxable: 0,
				image_src: '',
				class_length: 1,
				repeat_every: 1,
				month_repeat: '',
				repeat_each: '',
				registration_closes_days: 0,
				send_email_days: 1,
				send_text_days: 1,
				dates: []
			}
			this.detail.dates.push({ start_time: '12:00', end_time: '12:00' })
			this.showDetailTab = 'info'
			this.showDetail = true
			if (productId) {
				this.apiCall({ destination: 'get_item_class_product_info', data: { product_id: productId } }).then(obj => {
					if (obj.status == 'success') {
						this.detail.product_id = obj.product.product_id
						this.detail.description = obj.product.description
						this.detail.upc = obj.product.upc
						this.detail.detailed_description = obj.product.detailed_description
						this.detail.internal_use_only = obj.product.internal_use_only
						this.detail.inactive = obj.product.inactive
						this.detail.price = obj.product.pos
						this.detail.cost = obj.product.cost
						this.detail.not_taxable = obj.product.not_taxable
						this.detail.image_src = obj.product.image_src
						this.detail.category_id = obj.product.category_id
						this.detail.product_type_id = obj.product.product_type_id
					}
				}).catch(err => {
					console.log(err)
				})
			}
		},
		saveItem() {
			if (this.saving || !this.canSave) { return }
			this.saving = true
			this.messageStatus = ''
			this.message = 'Saving class ' + this.showDetailTab + '...'
			let postData = {
				class_detail_id: this.class_detail_id,
				section: this.showDetailTab
			}
			switch (this.showDetailTab) {
				case 'info':
					postData.client_id = this.getClientId
					postData.product_id = this.detail.product_id
					postData.product_type_id = this.detail.product_type_id
					postData.category_id = this.detail.category_id
					postData.description = this.detail.description
					postData.detailed_description = this.detail.detailed_description
					postData.upc = this.detail.upc,
					postData.not_taxable = this.detail.not_taxable,
					postData.internal_use_only = this.detail.internal_use_only,
					postData.inactive = this.detail.inactive,
					postData.seats_available = this.detail.seats_available,
					postData.price = this.detail.price,
					postData.cost = this.detail.cost
					postData.default_instructor = this.detail.default_instructor
					postData.recurring = this.detail.recurring
					break
				case 'dates':
					if (!this.detail.dates[0].date) {
						this.saving = false
						this.messageStatus = 'invalid'
						this.message = 'Please enter at least one date for this class'
						return
					}
					postData.dates = this.detail.dates
					postData.recurring = this.detail.recurring
					postData.class_frequency_code = this.detail.class_frequency_code
					postData.class_frequency_unit = this.detail.class_frequency_unit
					postData.class_frequency_id = this.detail.class_frequency_id
					postData.class_frequency_month_as_date = this.detail.class_frequency_month_as_date
					postData.class_frequency_end_date = this.detail.class_frequency_end_date
					break
				case 'registration':
					postData.registration_closes_days_before = this.detail.registration_closes_days_before
					postData.early_registration_closes_days_before = this.detail.early_registration_closes_days_before
					postData.early_registration_discount = this.detail.early_registration_discount
					postData.registration_required_fields = this.detail.registration_required_fields
					postData.registration_terms = this.detail.registration_terms
					break
				case 'notifications':
					postData.enable_email_reminder = this.detail.enable_email_reminder
					postData.email_reminder_subject = this.detail.email_reminder_subject
					postData.email_reminder_content = this.detail.email_reminder_content
					postData.email_reminder_days = this.detail.email_reminder_days
					postData.email_reply_to = this.detail.email_reply_to
					postData.enable_text_reminder = this.detail.enable_text_reminder
					postData.text_reminder_content = this.detail.text_reminder_content
					postData.text_reminder_days = this.detail.text_reminder_days
					postData.text_reply_to = this.detail.text_reply_to
					break
				case 'products':
					postData.products = []
					this.detail.products.forEach((product) => {
						postData.products.push(product.product_id)
					})
					break
			}
			this.apiCall({ destination: 'save_item_class_detail_' + this.showDetailTab, data: postData }).then(obj => {
				this.saving = false
                if (obj.status == 'success') {
					this.message = 'Class details saved!'
					setTimeout(() => { this.message = '' }, 1500)
					if (this.class_detail_id) {
						this.getItem()
					} else if (obj.class_detail_id) {
						this.$router.push('/range-memberships/classes/' + obj.class_detail_id)
					}
				} else {
                    this.message = obj.message
                    this.messageStatus = obj.status
                }
			}).catch(err => {
				console.log(err)
			})
		},
		cloneItem() {
			if (!this.class_detail_id) { return }
			if (this.saving) { return }
			this.showConfirmCloneClass = false
			this.messageStatus = ''
			this.message = 'Cloning class detail...'
			this.saving = true
			this.apiCall({ destination: 'save_item_class_clone', data: { class_detail_id: this.class_detail_id } }).then(obj => {
				this.saving = false
                if (obj.status == 'success') {
					this.message = 'Class detail cloned!'
					setTimeout(() => { this.message = '' }, 1500)
					if (obj.class_detail_id) {
						this.$router.push('/range-memberships/classes/' + obj.class_detail_id)
						this.showDetailTab = 'info'					
					}
				} else {
                    this.message = obj.message
                    this.messageStatus = obj.status
                }
			}).catch(err => {
				console.log(err)
			})
		},
		doExport() {
			if (this.gettingExport) { return false }
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList()
		},
		setShowDate(d) {
			this.showDate = d;
		},
		addDateTime() {
			if (this.detail.dates[this.detail.dates.length - 1].date) {
				let newDate = {
					date: '',
					start_time: this.detail.dates[this.detail.dates.length - 1].start_time,
					end_time: this.detail.dates[this.detail.dates.length - 1].end_time,
					instructor: this.detail.dates[this.detail.dates.length - 1].instructor,
					multi_session: false,
					session_count: 0,
					sessions: []
				}
				this.detail.dates.push(newDate)
			}
		},
		removeDateTime(index) {
			this.detail.dates.splice(index, 1)
			if (this.detail.dates.length == 0) {
				this.detail.dates.push({ date: '', start_time: '', end_time: '', instructor: '' })
			}
		},
		uploadSuccess(file, response) {
			var response = JSON.parse(response)
			this.currentImageSrc = response.image_src_large
			this.imageData = response.image_data
			this.$refs['imageDropzone'].removeAllFiles()
			this.imageUploadComplete = true
			this.detail.image_src = response.image_src
			this.detail.image_id = response.image_id
			this.detail.default_image = 0
		},
		theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
		cancelImageUpload() {
			this.showImageUplaod = false
			// reset the uploader image preview
			// this.currentImageSrc = ''
		},
		sendTestNotification() {
			//showTestNotification: '',
			//testNotificationRecipient: '',
			//sendingTest: false,
			this.testNotificationMessage = ''
			if (this.showTestNotification == 'email') {
				if (!this.testNotificationRecipient) {
					this.testNotificationMessage = 'Please enter an email address!'
					return
				}
				if (!this.$isValidEmailAddress(this.testNotificationRecipient)) {
					this.testNotificationMessage = 'Please enter a valid email address!'
					return
				}
				this.testNotificationMessage = 'Sending a test email...'
			} else {
				if (!this.testNotificationRecipient) {
					this.testNotificationMessage = 'Please enter a phone number!'
					return
				}
				if (!this.$isValidPhoneNumber(this.testNotificationRecipient)) {
					this.testNotificationMessage = 'Please enter a valid phone number!'
					return
				}
				this.testNotificationMessage = 'Sending a test text...'
			}
			this.sendingTest = true
			let postData = {
				class_detail_id: this.class_detail_id, 
				which: this.showTestNotification,
				recipient: this.testNotificationRecipient,
				email_reminder_subject: this.detail.email_reminder_subject,
				email_reminder_content: this.detail.email_reminder_content,
				text_reminder_content: this.detail.text_reminder_content
			}
			this.apiCall({ destination: 'send_class_test_notification', data: postData }).then(obj => {
				this.sendingTest = false
                if (obj.status == 'success') {
					if (this.showTestNotification == 'email') {
						this.testNotificationMessage = 'Test email sent!'
					} else {
						this.testNotificationMessage = 'Test text sent!'
					}
					setTimeout(() => { 
						this.testNotificationMessage = ''
						this.showTestNotification = ''
					}, 1500)
				} else {
                    this.testNotificationMessage = obj.message
                }
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss">
.class-detail-section {
	margin-bottom: 2em;
}

.select-days {
	display: grid;
    grid-template-columns: repeat(7, 1fr);
	margin: 0.5em 0 1em 0;
		.days-checkbox {
		grid-template-columns: auto;
		justify-items: center;
	}
}

.enrolled-content {
	max-height: 30em !important;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 1em 0.5em;
	font-weight: bolder;
	label {
		font-weight: normal;
	}
	.spacer-divider {
		grid-column: 1/3;
		border-bottom: 1px solid #d7d7d7;
	}
}


.recurring-classes {
	margin: 1em 0;
}

// NOTE: we can style elements inside a component IF scss is NOT scoped
.theme-default .cv-header .periodLabel {
	display: block;
	text-align: right;
	font-size: 1.75em;
}
.cv-week {
	min-height: 7em;
}
.cv-day {
	height: 7em;
}
</style>